/**
 * @author Fernando Ruano
 * @file index.js
 * @description Parameters Container
 */

// Dependencies
import React from 'react';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Parameters Container.
 * @return { Node } React Parameters container.
 */
const ParametersContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name Parameters.propTypes
 * @type { Object }
 */
ParametersContainer.propTypes = {};

/**
 * Default props
 */
ParametersContainer.defaultProps = {};

export default ParametersContainer;
